"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationInput = function (_Component) {
  _inherits(PaginationInput, _Component);

  function PaginationInput(p, s) {
    _classCallCheck(this, PaginationInput);

    var _this = _possibleConstructorReturn(this, (PaginationInput.__proto__ || Object.getPrototypeOf(PaginationInput)).call(this, p, s));

    _this.input = _react2.default.createRef();
    _this.onFocus = function () {
      if (_this.input) {
        _this.input.select();
      }
    };
    _this.onChange = function (e) {
      _this.props.onChange(e.target.value);
    };
    return _this;
  }

  _createClass(PaginationInput, [{
    key: "setFocusFromParent",
    value: function setFocusFromParent() {
      if (this.input) {
        this.input.current.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement("input", { type: "text", value: this.props.initialPageNumber,
        ref: this.input,
        className: "outline-none width-30 height-30 margin-left-10 margin-right-2 tag text-center border-all-1 border-dark-gray border-radius-4",
        onFocus: this.onFocus,
        onChange: this.onChange,
        id: "portfolio-all-holdings-page-box",
        "data-testid": "pagination-input",
        "aria-label": "Page " + this.props.initialPageNumber
      });
    }
  }]);

  return PaginationInput;
}(_react.Component);

exports.default = PaginationInput;